/**
 * Sets an user defined attribute
 * @param {string} name - Name of the attribute. Appears as column in the PageView event. It will also appear as a column in the PageAction event if you are using it.
 * @param {string|number|boolean|null} value - Value of the attribute. Appears as the value in the named attribute column in the PageView event.
 * @param {boolean} persist - Optional. If set to true, the name-value pair will also be set into the browser's storage API. Then on the following instrumented pages that load within the same session, the pair will be re-applied as a custom attribute.
 */
export const setCustomAttribute = (name, value, persist = false) => {
    var _a;
    if (!((_a = window === null || window === void 0 ? void 0 : window.newrelic) === null || _a === void 0 ? void 0 : _a.setCustomAttribute) || !name)
        return;
    window.newrelic.setCustomAttribute(name, value, persist);
};
/**
 * Reports a browser PageAction event along with a name and optional attributes.
 * @param {string} name - Name or category of the action. Reported as the actionName attribute.
 * @param {object} attributes - Optional. JSON object with one or more key/value pairs. For example: {key:"value"}. The key is reported as its own PageAction attribute with the specified values.
 */
export const addPageAction = (name, attributes = {}) => {
    var _a;
    if (!((_a = window === null || window === void 0 ? void 0 : window.newrelic) === null || _a === void 0 ? void 0 : _a.addPageAction) || !name)
        return;
    window.newrelic.addPageAction(name, attributes);
};
/**
 * Identifies a browser error without disrupting your app's operations.
 * @param {Error} error - Provide a meaningful error message that you can use when analyzing data on browser's JavaScript errors page.
 * @param {object} attributes - Optional. An object containing name/value pairs representing custom attributes.
 */
export const noticeError = (error, attributes = {}) => {
    var _a;
    if (!((_a = window === null || window === void 0 ? void 0 : window.newrelic) === null || _a === void 0 ? void 0 : _a.noticeError) || !(error instanceof Error))
        return;
    window.newrelic.noticeError(error, attributes);
};
